import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import PropTypes from 'prop-types';

const EditorOnReadyPlugin = ({ onReady }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (editor && onReady) {
      onReady(editor);
    }
  }, [editor, onReady]);

  return null;
};

EditorOnReadyPlugin.propTypes = {
  onReady: PropTypes.func.isRequired
};

export { EditorOnReadyPlugin };
